"use client"

import { Panda } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PandaIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PandaIcon = component(Icon)({ as: Panda })
